import { render } from "./empty.vue?vue&type=template&id=00fbfe9a"
const script = {}

import "./empty.vue?vue&type=style&index=0&id=00fbfe9a&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__